// frontend/app/utils/versionInfo.js
let _cache = null;
let _inflight = null;

/**
 * Fetches /version.json once and caches it for the session.
 * Returns the parsed JSON object or null.
 */
export async function getVersionInfo() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;

  _inflight = fetch("/version.json", { cache: "no-store" })
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null)
    .then((j) => {
      _cache = j;
      _inflight = null;
      return _cache;
    });

  return _inflight;
}

/**
 * Produces a compact client version string from version.json
 * Example: "2026.01.21.2-dev | AP_2026_01_18 | CE_2026_01_20"
 */
export function formatClientVersion(info) {
  if (!info) return null;
  const release = info.release_id || "unknown";
  const assetPack = info.asset_pack_id || "unknown";
  const contentExport = info?.content?.export_id || null;
  return contentExport ? `${release} | ${assetPack} | ${contentExport}` : `${release} | ${assetPack}`;
}
